<template>
    <template v-if="!button">
        <div class="search-display">
            <label for="search">ID jungo</label>
            <div class="controls">
                <input id="search" type="text" v-model=idJungo @keypress.enter="lookupPorteur" placeholder="ID Jungo">
                <button @click="lookupPorteur" class="primary-button-outlined"><i class="material-icons">search</i>Rechercher</button>
            </div>
        </div>
    </template>
    
    <template v-if="button">
        <div>
            <button class="secondary-button-outlined btn" @click.stop="lookupPorteurButton(porteur['NuméroIDduporteur'])"><i class="material-icons">autorenew</i></button>
        </div>
    </template>
</template>

<script setup>
import {onMounted, onUnmounted, ref} from 'vue';

const idJungo = ref('')
const pendingClientId = ref(null)

const props = defineProps({
    button: {type: Boolean, default: false},
    porteur: {type: Object, default: null}
})

// RECHERCHE du porteur
const lookupPorteur = () => {
    if (!idJungo.value) return
    if(idJungo.value == 911) idJungo.value = 12064011
    pendingClientId.value = String(idJungo.value).trim()
    window.postMessage({ type: 'storeClientId', clientId: idJungo.value }, '*');
}

// RECHERCHE du porteur variant button
const lookupPorteurButton = (item) => {
    if (!item) return
    pendingClientId.value = String(item).trim()
    window.postMessage({ type: 'storeClientId', clientId: item }, '*');
}


const emit = defineEmits(['select', 'alert']);

//FONCTION de nettoyage des charactèress spéciaux
function fixEncoding(str) {
  if (typeof str !== 'string') return str;
  return str
    .replace(/â/g, '’')
    .replace(/â/g, '–')
    .replace(/â”/g, '—')
    .replace(/â¦/g, '…')
    .replace(/Ã©/g, 'é')
    .replace(/Ã¨/g, 'è')
    .replace(/Ãª/g, 'ê')
    .replace(/Ã€/g, 'À')
    .replace(/Ã/g, 'à')
    .replace(/Ã´/g, 'ô')
    .replace(/Ã¢/g, 'â')
    .replace(/Ã¹/g, 'ù')
    .replace(/Ã»/g, 'û')
    .replace(/Ã§/g, 'ç')
    .replace(/Â/g, '')
    .replace(/à®/g,'î')
    .replace(/à¿/g,'ÿ')
}

// FONCTION de nettoyage des clés
function cleanClientDataKeys(dataArray) {
  return dataArray.map((obj) => {
    const cleanedObj = {};
    Object.keys(obj).forEach((key) => {
        const cleanKey = key
        .replace(/(^\s+|\s+$)/g, '')  // Trim leading/trailing whitespace
        .replace(/\s+/g, '')          // Remove all internal whitespace
        .replace(/[()]/g, '')
        .replace(/-/g,'')
        .replace(/\//g, '')
        .replace(/'/g,'')
        cleanedObj[cleanKey] = fixEncoding(obj[key])
    })

    return cleanedObj;
  });
}


// Listen for message from the CRM tab
const handleCrmData = (event) => {
    if (event.data?.type !== 'crmData' || !pendingClientId.value) return
    if (!Array.isArray(event.data.data) || !event.data.data.length) return
    const porteur = cleanClientDataKeys(event.data.data).find(
        item => String(item.NuméroIDduporteur).trim() === pendingClientId.value
    )
    if (!porteur) return
    pendingClientId.value = null
    emit('select', porteur)
    emit('alert', {message: "Porteur récupéré avec succès.", status: 'success-alert'})
}

onMounted(() => window.addEventListener('message', handleCrmData))
onUnmounted(() => window.removeEventListener('message', handleCrmData))

</script>

<style lang="scss" scoped>
html label, body label {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: .5rem;

    color: $dark-blue;
    font-weight: bold;
}

.search-display {
    display: flex;
    flex-direction: column;
    gap: .5rem;

    button {
        margin: auto;
    }

    .controls {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
    }
}

.btn {
    align-items: center;
    justify-content: center;
    height: 24px;
    padding: 0 8px;
}
</style>
